import React from 'react';

type Props = {
  hintStorageKey: string;
};

export default function InsuranceBalanceColumnTitle({ hintStorageKey }: Props) {
  return (
    <div>
      Insurance
      <br />
      Balance
    </div>
  );
}
